export default{
    
    //添加用户信息
    addUser(context,user){
        context.commit('context',user)
    }

}


// WEBPACK FOOTER //
// ./src/vuex/user/action.js